import type { CouponId, CouponIndex } from '../../../../schema/coupon/entry.js';
import type { WalletType } from '../../../../schema/frameworks/entry.js';
import type { ActivatedDrawId } from '../../../../schema/marketplace/entry.js';
import { getInstanceClient } from '../../../di/entry.browser.js';
import { PoolbettingError } from '../../../domain/entry.js';
import type { ActionResult } from '../../../lib/entry.js';

type UpdateCouponWalletArgs = {
  couponId: CouponId;
  couponIndices: CouponIndex[];
};

/**
 * Updates a given coupon wallet.
 *
 * @param payload Object containing new coupon wallet
 * @param root0 function args
 * @param root0.couponId Unique id of the coupon
 * @param root0.couponIndices Specific coupon ids in order to update board for
 * @returns SUCCESS if successful, otherwise ERROR
 */
export function updateCouponWallet(
  payload: ActivatedDrawId | WalletType,
  { couponId, couponIndices }: UpdateCouponWalletArgs
): ActionResult<undefined> {
  const updateCouponWalletController = getInstanceClient('IUpdateCouponWalletController');

  try {
    const isUpdated = updateCouponWalletController(payload, { couponId, couponIndices });

    if (!isUpdated) {
      return { status: 'ERROR', error: 'Det gick inte att uppdatera' };
    }

    return { status: 'SUCCESS', data: undefined };
  } catch (error) {
    if (PoolbettingError.isInstance(error)) {
      return error.toActionResult();
    }

    return { status: 'ERROR', error: 'Det gick inte att uppdatera' };
  }
}
